<template>
    <div class="conetent" style="background-color: #fff;">
   <!-- 顶部 -->
   <div class="nTop">
   	<div class="wrapper clearfix">
   		<a href="" class="logo"><img src="../../assets/images/logo.jpg" alt="佰吉宏安国际能源有限公司"><h1>佰吉宏安国际能源有限公司</h1></a>
   		<a class="nt-link1"><router-link  to="/home">返回首页</router-link></a>
   	</div>
   </div>
   <div class="banner_login" style="background: url(/static/image/bj_login1.jpg) center center no-repeat;"><b>忘记密码</b></div>
   
   <div class="forget">
   	<form action="">
   		<div class="clearfix">
   			<div class="item clearfix">
   				<label>手机号</label>
   				<input type="text" v-model="mobile" placeholder="请输入您的手机号">
   			</div>
   			<div class="item clearfix">
   				<label>验证码</label>
   				<input type="text"  v-model="yzm" placeholder="请输入验证码" class="inp1">
   				 <el-button @click="sendYanzheng" type="primary">{{send}}</el-button>
   			</div>
   			<div class="item clearfix">
   				<label>新密码</label>
   				<input type="text" v-model="psd" placeholder="请输入您的新密码">
   			</div>
   			<div class="item clearfix">
   				<label>确认新密码</label>
   				<input type="text" v-model="psds" placeholder="请确认您的新密码">
   			</div>
   		</div>
   		<a class="btn" @click="register()">确认</a>
   	</form>
   </div>
   
   <!-- 底部 -->
			<div class="footer">
			<div class="wrapper">
				<div class="f-nav">
					<a href=""><router-link  to="/home">首页</router-link></a>
					<a href=""><router-link  to="/about">关于我们</router-link></a>
					<a href=""><router-link  to="/honor">资质荣誉</router-link></a>
					<a href=""><router-link  to="/product">主营产品</router-link></a> 
					<a href=""><router-link  to="/bidding">招标信息</router-link></a>
					<a href=""><router-link  to="/partner">合作伙伴</router-link></a>
					<a href=""><router-link  to="/news">新闻资讯</router-link></a>
					<a href=""><router-link  to="/contact">联系我们</router-link></a>
				</div>
				<div class="f-box flexbox">
					<img src="../../assets/images/logo_foot.png" alt="佰吉宏安国际能源有限公司" class="logo_foot">
					<div class="f-center flexbox33 flexwarp" style="text-align: left;">
						<div class="f-item clearfix"><img src="../../assets/images/ico05.png"><p>联系电话：{{footerMassage.mobile}}</p></div>
						<div class="f-item clearfix"><img src="../../assets/images/ico06.png"><p>邮政编码：{{footerMassage.postal}}</p></div>
						<div class="f-item clearfix"><img src="../../assets/images/ico07.png"><p>访问量：{{footerMassage.pageviews}}</p></div>
						<div class="f-item clearfix"><img src="../../assets/images/ico08.png"><p>电子邮箱：{{footerMassage.email}}</p></div>
						<div class="f-item clearfix"><img src="../../assets/images/ico09.png"><p>公司地址：{{footerMassage.address}}</p></div>
						<div class="f-item clearfix"><img src="../../assets/images/ico10.png"><p>交易量：{{footerMassage.trading_volume}}</p></div>
					</div>
					<div class="qrcode">
						<img :src="footerMassage.image_id5_url" alt="">
						<p>扫一扫了解更多</p>
					</div>
				</div>
				<div class="copyright">
					Copyright  2021 ·版权所有 佰吉宏安国际能源有限公司　　<a  href="https://beian.miit.gov.cn" target="_blank">{{footerMassage.site_icp}}&nbsp;{{footerMassage.site_wabah}}</a><br>
					建议使用1920*1080以上的屏幕分辨率和8.0以上版本的浏览器来访问本站，本站不支持IE浏览器
				</div>
			</div>
		</div>
    </div>
</template>

<script>
    export default {
        name: 'register',
        data() {
            return {
                type: 2, // 2企业 1个人
				mobile:'',
				psd:'',
				psds:'',
				send:'发送验证码',
				time: 60,
				yzm:'',
				footerMassage:''
            }
        },
		mounted() {
			this.site_info()
		},
        methods: {
			//底部导航信息
			async site_info(idnex) {
			    let { status, message, data } = await this.$ajax('site_info', {
			    });
			    if (status == this.SUCCESS_CODE) {
			        
			      this.footerMassage = data
			    } else {
			        this.$message.error(message);
			    }
			},
			goBack(){
				 this.$router.go(-1);
			},
			register(){
				var _this = this
					if(_this.mobile == ''){
						_this.$message({
						  message: '请输入手机号',
						  type: 'warning'
						});
						return false
					}
					if (!/^1[2-9]\d{9}$/.test(_this.mobile)) {
						_this.$message({
						  message: '请输入有效的手机号',
						  type: 'warning'
						});
					    return false;
					}
					if(_this.psd == ''){
						_this.$message({
						  message: '请输入密码',
						  type: 'warning'
						});
						return false
					}
					if(_this.psds == ''){
						_this.$message({
						  message: '请再次输入密码',
						  type: 'warning'
						});
						return false
					}
					if(_this.psds != _this.psd){
						_this.$message({
						  message: '您两次输入的密码不同',
						  type: 'warning'
						});
						return false
					}
					
				
				if (_this.ysm == '') {
					_this.$message({
					  message: '请输入验证码',
					  type: 'warning'
					});
					_this.isYzm = true
					return false;
				}else{
					_this.isYzm = false
				}
				this.submit()
			},
			async submit() {
				var _this = this;
				let { status, message, data } = await _this.$ajax('password', {
					mobile:this.mobile,
					verify:this.yzm,	
					password:this.psd,
				});
				if (status == _this.SUCCESS_CODE) {
					  _this.$message({
						message: '修改成功！',
						type: 'success'
					  });
					  _this.$router.go(-1);
				} else {
					 _this.$message.error(message);
				}
  			},
			// 发送验证码
			sendYanzheng(){
			    var _this = this;
			    if (!/^1[2-9]\d{9}$/.test(_this.mobile)) {
					_this.$message({
					  message: '请输入有效的手机号',
					  type: 'warning'
					});
					_this.isMobile = true
			        return false;
			    }else{
					_this.isMobile = false
				}
			    if (_this.send != '发送验证码') return;
				_this.getVerify()
			},
			async getVerify() {
				var _this = this;
				_this.isMobile = false
			   let { status, message, data } = await _this.$ajax('verify', {
			   	mobile:_this.mobile,
				type:3
			   });
			   if (status == _this.SUCCESS_CODE) {
				   // _this.yzm = data
				   _this.$message({
						message: '发送成功！请注意查收',
						type: 'success'
				   });
					_this.countDown()
			   } else {
			        _this.$message.error(message);
			   }
			},
			// 验证码倒计时
			countDown() { //验证码倒计时
			    var _this = this;
			    switch (_this.send) {
			        case '发送验证码':
			            _this.send = _this.time + 's';
			            var timer = setInterval(function () {
			                if (--_this.time <= 0) {
			                    clearInterval(timer);
			                    _this.send = '发送验证码';
			                    _this.time = 60;
			                } else {
			                    _this.send = _this.time + 's';
			                }
			            }, 1000);
			            break;
			    }
			},
		
        }
    }
</script>

<style scoped>
.forget{width: 900px;margin: 0 auto;padding: 165px 0 220px;}
		.forget .item{width: 430px;float: left;margin-bottom: 25px;}
		.forget .item:nth-child(2n){float: right;}
		.forget .item label{display: block;width: 88px;float: left;font-size: 16px;color: #323232;line-height: 45px;}
		.forget .item input{display: block;width: calc(100% - 88px);border: 1px solid #dfdfdf;border-radius: 3px;box-shadow: 0 3px 5px rgba(0,0,0,.05);height: 45px;float: left;padding: 0 18px;font-size: 14px;color: #323232;}
		.forget .item input::-webkit-input-placeholder{color: #c0c4cc;}
		.forget .item input::-moz-placeholder{color: #c0c4cc;}
		.forget .item input:-moz-placeholder{color: #c0c4cc;}
		.forget .item .inp1{width: 198px;transition: .5s;}
		.forget .item .yzm{display: block;width: 128px;height: 45px;border-radius: 5px;text-align: center;line-height: 45px;background: #106a95;font-size: 16px;color: #fff;float: right;box-shadow: 0 3px 5px rgba(0,0,0,.05);}
		.forget .btn{display: block;width: 210px;height: 50px;background: #af2f24;border-radius: 5px;text-align: center;line-height: 50px;color: #fff;font-weight: bold;font-size: 22px;margin-top: 20px;transition: .5s;}
		.forget .yzm:hover,.forget .btn:hover{opacity: .9;}
	
</style>



// WEBPACK FOOTER //
// src/views/forget/forget.vue